import React from "react";
import { Menu } from "lucide-react";
import { Logo } from "./Logo";
import { Button } from "./ui/button";
import { Dialog, DialogContent } from "./ui/dialog";
import { Sheet, SheetContent } from "./ui/sheet";
import { navigate } from "../lib/router";
import { useLanguage } from "../contexts/LanguageContext";
import { navbarLabels } from "./Navbar.labels";
import { LanguageSelect } from "./LanguageSelect";

export function Navbar() {
  const [open, setOpen] = React.useState(false);
  const { lang } = useLanguage();
  const t = navbarLabels[lang];

  const NavLinks = ({
    className = "",
    onClick,
  }: {
    className?: string;
    onClick?: () => void;
  }) => (
    <div className={`flex flex-col md:flex-row md:items-center gap-4 ${className}`}>
      <button
        onClick={() => {
          navigate("/");
          onClick?.();
        }}
        className="text-sm font-medium hover:underline underline-offset-4 text-left"
      >
        {t.home}
      </button>
      <button
        onClick={() => {
          navigate("/blog");
          onClick?.();
        }}
        className="text-sm font-medium hover:underline underline-offset-4 text-left"
      >
        {t.blog}
      </button>
    </div>
  );

  return (
    <>
      <header className="fixed md:sticky top-0 z-50 w-full border-b bg-white">
        <div className="flex h-16 w-full items-center px-4">
          <button
            type="button"
            aria-label={t.goHome}
            onClick={() => navigate("/")}
            className="flex items-center"
          >
            <Logo className="h-8 w-auto cursor-pointer" />
          </button>
          <nav className="ml-auto hidden md:flex items-center gap-4">
            <NavLinks className="flex-row" />
            <LanguageSelect labels={t.language} />
            <Button variant="primary" onClick={() => navigate("/login")}>{t.login}</Button>
          </nav>
          <div className="md:hidden ml-auto flex items-center">
            <Button variant="ghost" size="icon" onClick={() => setOpen(true)}>
              <Menu className="h-6 w-6" />
              <span className="sr-only">{t.openMenu}</span>
            </Button>
          </div>
        </div>

        <Sheet open={open} onOpenChange={setOpen}>
          <SheetContent side="right" className="h-full w-64 rounded-none border-l p-6 flex flex-col gap-4">
            <NavLinks onClick={() => setOpen(false)} />
            <LanguageSelect className="w-full" labels={t.language} />
            <Button
              variant="primary"
              onClick={() => {
                navigate("/login");
                setOpen(false);
              }}
              className="justify-start"
            >
              {t.login}
            </Button>
          </SheetContent>
        </Sheet>
      </header>
      <div className="h-16 md:hidden" />
    </>
  );
}

export default Navbar;
